import { ChangeDetectorRef } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { HelpModalService } from '../services/help-modal.service';
import { YChartsSentryUtils } from 'Angular/services/sentry/sentry-utils';
import * as i0 from "@angular/core";
import * as i1 from "../services/help-modal.service";
import * as i2 from "@angular/common";
import * as i3 from "../../modal-base/components/modal-base.component";
import * as i4 from "../../modal-base/components/simple-modal-header.component";
function HelpModalComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 5)(2, "div", 6);
    i0.ɵɵtext(3, "Loading...");
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "div", 7);
    i0.ɵɵelementEnd()();
} }
function HelpModalComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵelement(1, "div", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.state.helpModalInfo.content, i0.ɵɵsanitizeHtml);
} }
function HelpModalComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 4)(1, "div", 9);
    i0.ɵɵtext(2, "An error has occurred.");
    i0.ɵɵelementEnd()();
} }
/**
 *
 * Help Modal Component
 *
 */
export class HelpModalComponent {
    constructor(changeDetector, helpModalService) {
        this.changeDetector = changeDetector;
        this.helpModalService = helpModalService;
        this.state = {
            helpModalInfo: null,
            loading: true,
            modalOpen: false,
            error: false,
        };
    }
    openModal(name) {
        this.helpModalService
            .getHelpPopup(name)
            .pipe(finalize(() => {
            this.state.loading = false;
            this.state.modalOpen = true;
            this.changeDetector.markForCheck();
        }))
            .subscribe({
            next: (data) => {
                this.state.helpModalInfo = data;
                this.state.error = false;
            },
            error: (e) => {
                this.state.helpModalInfo = null;
                this.state.error = true;
                YChartsSentryUtils.captureException(e);
            },
        });
    }
    closeModal() {
        this.state.modalOpen = false;
        this.changeDetector.markForCheck();
    }
}
HelpModalComponent.ɵfac = function HelpModalComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || HelpModalComponent)(i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i1.HelpModalService)); };
HelpModalComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: HelpModalComponent, selectors: [["ycn-help-modal"]], standalone: false, decls: 6, vars: 6, consts: [[3, "closeModalHandler", "extraModalClasses", "open"], [3, "closeModalHandler", "header"], [1, "modal-body"], ["class", "modal-section", 4, "ngIf"], [1, "modal-section"], [1, "loader"], [1, "loader-message"], [1, "loader-spinner"], [1, "modal-message", 3, "innerHTML"], [1, "modal-message"]], template: function HelpModalComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "ycn-modal-base", 0);
        i0.ɵɵlistener("closeModalHandler", function HelpModalComponent_Template_ycn_modal_base_closeModalHandler_0_listener() { return ctx.closeModal(); });
        i0.ɵɵelementStart(1, "ycn-simple-modal-header", 1);
        i0.ɵɵlistener("closeModalHandler", function HelpModalComponent_Template_ycn_simple_modal_header_closeModalHandler_1_listener() { return ctx.closeModal(); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵtemplate(3, HelpModalComponent_div_3_Template, 5, 0, "div", 3)(4, HelpModalComponent_div_4_Template, 2, 1, "div", 3)(5, HelpModalComponent_div_5_Template, 3, 0, "div", 3);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵproperty("extraModalClasses", "modal-sm")("open", ctx.state.modalOpen);
        i0.ɵɵadvance();
        i0.ɵɵproperty("header", "Help");
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", ctx.state.loading);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.state.helpModalInfo);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.state.error);
    } }, dependencies: [i2.NgIf, i3.ModalBaseComponent, i4.SimpleModalHeaderComponent], encapsulation: 2, changeDetection: 0 });
